import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
// 名字改了  类名改了  后面的BaseId 和Id也根据Rdo来改
@Pipe({
  name: 'datePipe'
})
export class GDatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      var timestamp = Date.parse(value);
      return moment(timestamp).format();
    }
  }
}
